import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserProfileResponse } from '../../models/user-profile-response';
import { UserProfileRequest } from '../../../edit-user-profile/models/user-profile-request';
import { UserProfileExecutorRequest } from '../../../edit-executor-profile/models/user-profile-executor-request';
import { UserAvailabilityResponse } from '../../../user-availability/models/user-availability-response';
import { UpdateUserAvailabilityRequest } from '../../../user-availability/models/update-user-availability-request';
import { ApiRouteConstants } from '../../../../../../core/constants/api-routes';

@Injectable({
    providedIn: 'root',
})
export class UserProfileService {
    private readonly userProfileApiRoute = ApiRouteConstants.UserProfile;

    constructor(private readonly http: HttpClient) {}

    get(): Promise<UserProfileResponse> {
        return lastValueFrom(
            this.http.get<UserProfileResponse>(
                this.userProfileApiRoute.rootUrl,
            ),
        );
    }

    getById(id: number): Promise<UserProfileResponse> {
        return lastValueFrom(
            this.http.get<UserProfileResponse>(
                `${this.userProfileApiRoute.rootUrl}/${id}`,
            ),
        );
    }

    update(request: UserProfileExecutorRequest): Promise<UserProfileResponse> {
        return lastValueFrom(
            this.http.patch<UserProfileResponse>(
                this.userProfileApiRoute.rootUrl,
                request,
            ),
        );
    }

    updateById(
        id: number,
        request: UserProfileRequest,
    ): Promise<UserProfileResponse> {
        return lastValueFrom(
            this.http.patch<UserProfileResponse>(
                `${this.userProfileApiRoute.rootUrl}/${id}`,
                request,
            ),
        );
    }

    getUserAvailability(userId: number): Observable<UserAvailabilityResponse> {
        return this.http.get<UserAvailabilityResponse>(
            this.userProfileApiRoute.getUserAvailabilityUrl(userId),
        );
    }

    updateUserAvailability(
        userId: number,
        userAvailability: UpdateUserAvailabilityRequest,
    ): Observable<UserAvailabilityResponse> {
        return this.http.post<UserAvailabilityResponse>(
            this.userProfileApiRoute.getUserAvailabilityUrl(userId),
            userAvailability,
        );
    }
}
